export default "__VITE_ASSET__Chl7L5Ya__"